import { Action } from '@ngrx/store';
import { User } from '../../../_models/user';
import { CuttingTable } from '../../../_models/cutting_table';
import { CuttingTableType } from '../../../_models/cutting_table_type';

export enum CuttingTableActitonTypes {

  ClearCuttingTable = '[CuttingTable] Clear',
  InicializeCuttingTable = '[CuttingTable] Inicialize',

  GetCurrentCuttingTable = '[CuttingTable] Get Current',
	SetCurrentCuttingTable = '[CuttingTable] Set Current',
	SetCurrentCuttingTableId = '[CuttingTable] Set Current Id',

	SetFilterFields = '[CuttingTable] Set Filter Fields',

	LoadCuttingTables = '[CuttingTable] Get List',
	LoadCuttingTablesSuccess = '[CuttingTable] Load Success',
  LoadCuttingTablesFail = '[CuttingTable] Load Fail',

  LoadCuttingTableTypes = '[CuttingTable] Get Type List',
  LoadCuttingTableTypesSuccess = '[CuttingTable] Load Type Success',
  LoadCuttingTableTypesFail = '[CuttingTable] Load Type Fail',

  UpdateCuttingTable = '[CuttingTable] Update',
  UpdateCuttingTableSuccess = '[CuttingTable] Update Success',
	UpdateCuttingTableFail = '[CuttingTable] Update Fail',

	CreateCuttingTable = '[CuttingTable] Create',
  CreateCuttingTableSuccess = '[CuttingTable] Create Success',
	CreateCuttingTableFail = '[CuttingTable] Create Fail',

	DeleteCuttingTable = '[CuttingTable] Delete',
  DeleteCuttingTableSuccess = '[CuttingTable] Delete Success',
	DeleteCuttingTableFail = '[CuttingTable] Delete Fail',

	LoadUsers = '[CuttingTable] Get Users',
	LoadUsersSuccess = '[CuttingTable] Load Users Success',
  LoadUsersFail = '[CuttingTable] Load Users Fail'
}

export class ClearCuttingTable implements Action {
	readonly type = CuttingTableActitonTypes.ClearCuttingTable;
}

export class InicializeCuttingTable implements Action {
	readonly type = CuttingTableActitonTypes.InicializeCuttingTable;
}

export class GetCurrentCuttingTable implements Action {
	readonly type = CuttingTableActitonTypes.GetCurrentCuttingTable;
}

export class SetCurrentCuttingTable implements Action {
	readonly type = CuttingTableActitonTypes.SetCurrentCuttingTable;

	constructor(public payload: CuttingTable) {}
}

export class SetCurrentCuttingTableId implements Action {
	readonly type = CuttingTableActitonTypes.SetCurrentCuttingTableId;

	constructor(public payload: bigint) {}
}

export class SetFilterFields implements Action {
	readonly type = CuttingTableActitonTypes.SetFilterFields;

	constructor(public payload: any) {}
}

export class LoadCuttingTables implements Action {
	readonly type = CuttingTableActitonTypes.LoadCuttingTables;

	constructor(public payload: any) {}
	// constructor(public payload: {
    //   finished: boolean,
    //   searchDesc: string,
    //   searchName: string
    // }) {}
}

export class LoadCuttingTablesSuccess implements Action {
	readonly type = CuttingTableActitonTypes.LoadCuttingTablesSuccess;

	constructor(public payload: CuttingTable[]) {}
}

export class LoadCuttingTablesFail implements Action {
	readonly type = CuttingTableActitonTypes.LoadCuttingTablesFail;

	constructor(public payload: string) {}
}

export class LoadCuttingTableTypes implements Action {
	readonly type = CuttingTableActitonTypes.LoadCuttingTableTypes;

	constructor(public payload: any) {}
}

export class LoadCuttingTableTypesSuccess implements Action {
	readonly type = CuttingTableActitonTypes.LoadCuttingTableTypesSuccess;

	constructor(public payload: CuttingTableType[]) {}
}

export class LoadCuttingTableTypesFail implements Action {
	readonly type = CuttingTableActitonTypes.LoadCuttingTableTypesFail;

	constructor(public payload: string) {}
}

export class UpdateCuttingTable implements Action {
	readonly type = CuttingTableActitonTypes.UpdateCuttingTable;

	constructor(public payload: CuttingTable) {}
}

export class UpdateCuttingTableSuccess implements Action {
	readonly type = CuttingTableActitonTypes.UpdateCuttingTableSuccess;

	constructor(public payload: CuttingTable) {}
}

export class UpdateCuttingTableFail implements Action {
	readonly type = CuttingTableActitonTypes.UpdateCuttingTableFail;

	constructor(public payload: string) {}
}

export class DeleteCuttingTable implements Action {
	readonly type = CuttingTableActitonTypes.DeleteCuttingTable;

	constructor(public payload: CuttingTable) {}
}

export class DeleteCuttingTableSuccess implements Action {
	readonly type = CuttingTableActitonTypes.DeleteCuttingTableSuccess;

	constructor(public payload: bigint) {}
}

export class DeleteCuttingTableFail implements Action {
	readonly type = CuttingTableActitonTypes.DeleteCuttingTableFail;

	constructor(public payload: string) {}
}

export class CreateCuttingTable implements Action {
	readonly type = CuttingTableActitonTypes.CreateCuttingTable;

	constructor(public payload: CuttingTable) {}
}

export class CreateCuttingTableSuccess implements Action {
	readonly type = CuttingTableActitonTypes.CreateCuttingTableSuccess;

	constructor(public payload: CuttingTable) {}
}

export class CreateCuttingTableFail implements Action {
	readonly type = CuttingTableActitonTypes.CreateCuttingTableFail;

	constructor(public payload: string) {}
}

// ------- AGENTES COMERCIALES --------
export class LoadUsers implements Action {
	readonly type = CuttingTableActitonTypes.LoadUsers;
}

export class LoadUsersSuccess implements Action {
	readonly type = CuttingTableActitonTypes.LoadUsersSuccess;

	constructor(public payload: User[]) {}
}

export class LoadUsersFail implements Action {
	readonly type = CuttingTableActitonTypes.LoadUsersFail;

	constructor(public payload: string) {}
}

// Unión de acciones
export type CuttingTableActions = ClearCuttingTable
| InicializeCuttingTable
| GetCurrentCuttingTable
| SetCurrentCuttingTable
| SetCurrentCuttingTableId
| SetFilterFields
| LoadCuttingTables
| LoadCuttingTablesSuccess
| LoadCuttingTablesFail
| LoadCuttingTableTypes
| LoadCuttingTableTypesSuccess
| LoadCuttingTableTypesFail
| UpdateCuttingTable
| UpdateCuttingTableSuccess
| UpdateCuttingTableFail
| CreateCuttingTable
| CreateCuttingTableSuccess
| CreateCuttingTableFail
| DeleteCuttingTable
| DeleteCuttingTableSuccess
| DeleteCuttingTableFail
| LoadUsers
| LoadUsersSuccess
| LoadUsersFail;
